<template>
  <v-card class="d-flex flex-column align-center rounded elevation-3 mb-16" :class="!$vuetify.breakpoint.smAndUp ? 'px-4 py-10' : 'pa-10'" min-height="75vh">
    <slot name="acknowledgement-header">
      <v-icon color="primary darken-1" class="xxl-icon">mdi-check-circle-outline</v-icon>
      <p class="acknowledgement-title text-center text-h5 primary--text text--darken-1 font-weight-bold mb-4">
        {{ title }}
      </p>
    </slot>
    <slot name="acknowledgement-body">
      <p class="acknowledgement-body text-center mb-8">
        {{ body }}
      </p>
    </slot>
    <slot name="contact">
      <div v-if="!noEmailBox" class="email-us--wrapper d-flex flex-column align-center px-8 py-4 mb-12 rounded-lg">
        <v-icon x-large color="primary darken-1" class="mb-2">mdi-email-outline</v-icon>
        <p class="text-center">
          {{ $t('message.emailCustomerSupportForQueries') }}
          <a :href="`mailto:${customerServiceEmail}`">{{ customerServiceEmail }}</a>
        </p>
      </div>
    </slot>
    <slot name="acknowledgement-actions">
      <app-button invert gradient :label="buttonLabel ? buttonLabel : $t('button.done')" :to="buttonLink" width="10rem" class="mt-auto" />
    </slot>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { ROUTE_NAME } from '@/constants/route.constants'
import { localeHelper } from '@/utils'

export default {
  props: {
    title: { type: String, required: false },
    body: { type: String, required: false },
    noEmailBox: { type: Boolean, default: false },
    buttonLink: { type: [String, Object], default: () => ({ name: ROUTE_NAME.HOME }) },
    buttonLabel: { type: String, required: false }
  },
  computed: {
    ...mapGetters('page', ['customerServiceEmail'])
  }
}
</script>

<style lang="scss">
.xxl-icon {
  font-size: 8rem !important;
}

.acknowledgement-title,
.acknowledgement-body {
  max-width: 30rem;
}

.email-us--wrapper {
  border: 1px solid var(--v-primary-lighten1);
  max-width: 20rem;
}
</style>
